import React, { Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Parameter from './Parameter';

// Info modal component begins
const ParameterModal = (props) => {
  return (
    <Fragment>
      <div className="modal parametersModal">
        <div id="showParams" onClick={props.showModal} className="exitModal">
          <FontAwesomeIcon icon="times" className="icon" />
        </div>
        <h2>Advanced options</h2>
        <p className="modalDescription">Select up to two comparison metrics.</p>
        <div className="allParameters">
          {props.parameters.map((parameter, i) => {
            return (
              <Parameter
                name={parameter.name}
                value={parameter.id}
                key={parameter.id}
                id={parameter.id}
                checked={parameter.checked}
                handleParamChange={props.handleParamChange}
              />
            );
          })}
      </div>
      </div>
      <div className="modalBackground"></div>
    </Fragment>
  )
}

export default ParameterModal;